import * as React from "react";
import ReactPlayer from "react-player/youtube";
import { useNavigate } from "react-router-dom";

const VideoTraining = () => {
  const navigate = useNavigate();
  if (localStorage.getItem("userid") === null) navigate("/logout");
  return (
      <div>
    <h1 align="center">Training Modules</h1>
      <div className="row">
        <div className="row justify-content-center" style={{ padding:'70px'} }>
          <div className="col-3">
            {" "}
            <ReactPlayer
              url="https://www.youtube.com/watch?v=5qZuwSfnUKU"
              width={"100%"}
            />
          </div>
          <div className="col-3">
            {" "}
            <ReactPlayer
              url="https://www.youtube.com/watch?v=8zt-jZOc7vA"
              width={"100%"}
            />
            </div>
        </div>
      </div>
    </div>
  );
};

export default VideoTraining;
